import { Businesses, Theme } from "@just-in-types";
import * as React from "react";
import styled from "react-emotion";
import { connect } from "react-redux";
import Column from "../components/Column";
import Select from "../components/Select";
import Text from "../components/Text";
import { IState } from "../store/reducers";
import { IStrings } from "../store/reducers/strings";
import { HandleSelect } from "../views/Vehicles";

interface IYmmOwnProps {
  businessId: string;
  onHandleSelect: HandleSelect;
  colors: Theme.Colors;
  disabled: boolean;
  make: null | string;
  makes: string[];
  models: string[];
  site: Businesses.Site;
  yearMax: null | number;
  yearMin: null | number;
  yearSwitch? : boolean;
}
interface IYmmStateProps {
  languageStrings: IStrings;
}
type YmmProps = IYmmOwnProps & IYmmStateProps;

interface IYmmState {
  years: number[];
}
type YmmState = IYmmState;

const SelectRows = styled("div")`
  display: grid;
  grid-template-columns: 3fr 5fr;
  width: 50vw;
  grid-row-gap: 2vh;
`;
interface ISelectLabelProps {
  color?: string;
  disabled: boolean;
}
const SelectLabel = styled(Text)`
  color: ${(props: ISelectLabelProps) => props.color};
  margin-right: 2rem;
  opacity: ${(props: ISelectLabelProps) => (props.disabled ? 0.25 : 1)};
  transition: opacity 250ms ease-in-out;
`;

class Ymm extends React.Component<YmmProps, YmmState> {
  constructor(props: YmmProps) {
    super(props);

    const years: number[] = [];
    const currentYear = new Date().getFullYear();

    if (props.businessId === "f409TtMdBsgZosA1noFQ" || props.businessId === "zTaYJYiGLHRy9PNwR671") {
      // if Airline OR US Auto, only show 2000-2020
      years.push(2000);
      for (let i = 2001; i <= currentYear; i++) {
        years.push(i);
      }
      years.push(currentYear);
    } else {
      let maxYear = props.yearSwitch ? currentYear : currentYear - 10;
      if (props.businessId === "3DmMhzu7mCa3hpLUEbp9") {
        // if business is U Pull U Save, then show all years, including newer years (ie, 2011-2021)
        maxYear = currentYear;
      }

      years.push(1960);
      for (let i = 1980; i <= maxYear; i++) {
        years.push(i);
      }
      years.push(currentYear);
    }

    this.state = { years };
  }

  public handleSelect = (event: React.FormEvent<HTMLSelectElement>) => this.props.onHandleSelect(event);

  public render() {
    const {
      colors,
      disabled,
      languageStrings: strings,
      make,
      makes,
      models,
      site: { kioskUiTextColor },
      yearMax,
      yearMin,
    } = this.props;
    const { years } = this.state;

    let sortedYears = [];
    if (this.props.businessId === "f409TtMdBsgZosA1noFQ") {
      // if Airline, sort desc
      sortedYears = this.sortDesc(years);
    } else {
      sortedYears = this.sortAsc(years);
    }

    return (
      <Column align="center" justify="center">
        <SelectRows>
          <SelectLabel color={kioskUiTextColor ? kioskUiTextColor : colors.secondary} disabled={false} size="2rem">
            {`${strings.minYear}:`}
          </SelectLabel>
          <Select bg="white" disabled={disabled} name="yearMin" onChange={this.handleSelect} size="1.5rem">
            <option value="none">{`${strings.select} ${strings.minYear}:`}</option>
            {sortedYears.map((year, index) => (
              <option key={index} selected={year === yearMin} value={year}>
                {year}
              </option>
            ))}
          </Select>
          <SelectLabel color={kioskUiTextColor ? kioskUiTextColor : colors.secondary} disabled={false} size="2rem">
            {`${strings.maxYear}:`}
          </SelectLabel>
          <Select
            bg="white"
            disabled={!yearMin || disabled}
            name="yearMax"
            onChange={this.handleSelect}
            size="1.5rem"
            value={yearMax === null ? "none" : yearMax.toString()}
          >
            <option value="none">{`${strings.select} ${strings.maxYear}:`}</option>
            {sortedYears
              .filter((year) => (yearMin ? year >= yearMin : true))
              .map((year, index) => (
                <option key={index} value={year}>
                  {year}
                </option>
              ))}
          </Select>
          <SelectLabel
            color={kioskUiTextColor ? kioskUiTextColor : colors.secondary}
            disabled={yearMax === null}
            size="2rem"
          >
            {`${strings.make}:`}
          </SelectLabel>
          <Select bg="white" disabled={false} name="make" onChange={this.handleSelect} size="1.5rem">
            <option value="none">{`${strings.select} ${strings.make}:`}</option>
            {this.sortAsc(makes).map((makeA, index) => (
              <option key={index} value={makeA}>
                {makeA}
              </option>
            ))}
          </Select>
          <SelectLabel
            color={kioskUiTextColor ? kioskUiTextColor : colors.secondary}
            disabled={make === null}
            size="2rem"
          >
            {`${strings.model}:`}
          </SelectLabel>
          <Select
            bg="white"
            disabled={make === null || disabled}
            name="model"
            onChange={this.handleSelect}
            size="1.5rem"
          >
            <option value="none">{`${strings.select} ${strings.model}:`}</option>
            {models.length === 0 ? (
              <option value="none">{strings.noModels}</option>
            ) : (
              this.sortAsc(models).map((modelB, index) => (
                <option key={index} value={modelB}>
                  {modelB}
                </option>
              ))
            )}
          </Select>
        </SelectRows>
      </Column>
    );
  }

  private sortAsc = (unsorted: Array<number | string>) => unsorted.sort((a, b) => (a === b ? 0 : a > b ? 1 : -1));

  private sortDesc = (unsorted: Array<number | string>) => unsorted.sort((a, b) => (a === b ? 0 : a > b ? -1 : 1));
}

const mapStateToProps = ({ router: { languageStrings } }: IState) => ({
  languageStrings,
});

export default connect(mapStateToProps)(Ymm);



// WEBPACK FOOTER //
// ./src/components/Ymm.tsx